import React, { useContext } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
    Accordion,
    AccordionDetails,
    AccordionSummary, Link, Table,
    TableBody,
    TableCell, TableRow, Typography
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { ZonaOptions } from '../../../../helpers';
import { StoricoUfficioContext } from '../StoricoUfficioContext';

const LinkRouter = props => <Link {...props} component={RouterLink} />;

export const UfficioDetails = ({
    disabled,
    formRef,
    onActionClick,
    ...props }) => {

    const {
        state,
        setState,
    } = useContext(StoricoUfficioContext);

    const {
        storicoUfficio
    } = state;



    const buildTableCellRowComponent = (key, value, oldValue) => {
        return (<TableRow>
            <TableCell style={{ width: "20%" }}>
                {key}
            </TableCell>
            <TableCell>
                <div>
                    {value ?? '-'}
                </div>
                {(oldValue && value != oldValue ? <div style={{
                    //backgroundColor: 'rgba(255, 0, 0, 0.6)',
                    textDecoration: 'line-through',
                    color: 'red'
                }}>
                    {oldValue}
                </div> : <div />)}
            </TableCell>
        </TableRow>);
    }



    return (
        <>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                    aria-controls="ufficio-panel"
                    id="ufficio-panel"
                    sx={{
                        color: "white",
                        backgroundColor: "secondary.main",
                    }}
                >
                    <Typography variant="h6">Ufficio</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0 }}>
                    <Table>
                        <TableBody>
                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Nome
                                </TableCell>
                                <TableCell>
                                    {storicoUfficio?.valore.Nome ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Nome", storicoUfficio?.valore.Nome, storicoUfficio?.valorePrecedente.Nome)}

                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Comune
                                </TableCell>
                                <TableCell>
                                    {storicoUfficio?.valore.Comune?.DenominazioneIt ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Comune", storicoUfficio?.valore.Comune?.DenominazioneIt, storicoUfficio?.valorePrecedente.Comune?.DenominazioneIt)}
                            {/* 
                            <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Tipo
                                </TableCell>
                                <TableCell>
                                    {storicoUfficio?.valore.Tipo?.Nome ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Tipo", storicoUfficio?.valore.TipoUfficio?.Nome, storicoUfficio?.valorePrecedente.TipoUfficio?.Nome)}
                            {buildTableCellRowComponent("Convalidato", storicoUfficio?.valore.Convalidato, storicoUfficio?.valorePrecedente.Convalidato)}

                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Codice ufficio
                                </TableCell>
                                <TableCell>
                                    {storicoUfficio?.valore.CodiceUfficio ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Codice ufficio", storicoUfficio?.valore.CodiceUfficio, storicoUfficio?.valorePrecedente.CodiceUfficio)}

                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Code new
                                </TableCell>
                                <TableCell>
                                    {storicoUfficio?.valore.CodeNew ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Code new", storicoUfficio?.valore.CodeNew, storicoUfficio?.valorePrecedente.CodeNew)}

                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Codice istat ubicazione
                                </TableCell>
                                <TableCell>
                                    {storicoUfficio?.valore.CodiceIstatUbicazione ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Codice istat ubicazione", storicoUfficio?.valore.CodiceIstatUbicazione, storicoUfficio?.valorePrecedente.CodiceIstatUbicazione)}

                            {buildTableCellRowComponent("Msg", storicoUfficio?.valore.Msg, storicoUfficio?.valorePrecedente.Msg)}
                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Status
                                </TableCell>
                                <TableCell>
                                    {storicoUfficio?.valore.Status ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Status", storicoUfficio?.valore.Status, storicoUfficio?.valorePrecedente.Status)}

                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Cap
                                </TableCell>
                                <TableCell>
                                    {storicoUfficio?.valore.Cap ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Cap", storicoUfficio?.valore.Cap, storicoUfficio?.valorePrecedente.Cap)}
                            {/* 
                            <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Codice fiscale
                                </TableCell>
                                <TableCell>
                                    {storicoUfficio?.valore.CodiceFiscale ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Codice fiscale", storicoUfficio?.valore.CodiceFiscale, storicoUfficio?.valorePrecedente.CodiceFiscale)}

                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Patrono
                                </TableCell>
                                <TableCell>
                                    {storicoUfficio?.valore.Patrono ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Festività locale", storicoUfficio?.valore.Patrono, storicoUfficio?.valorePrecedente.Patrono)}

                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Indirizzo
                                </TableCell>
                                <TableCell>
                                    {storicoUfficio?.valore.Indirizzo ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Indirizzo", storicoUfficio?.valore.Indirizzo, storicoUfficio?.valorePrecedente.Indirizzo)}

                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Lingue parlate
                                </TableCell>
                                <TableCell>
                                    {storicoUfficio?.valore.LingueParlate ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Lingue parlate", storicoUfficio?.valore.LingueParlate, storicoUfficio?.valorePrecedente.LingueParlate)}

                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    VideoConferenza
                                </TableCell>
                                <TableCell>
                                    {storicoUfficio?.valore.VideoConferenza ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("VideoConferenza", storicoUfficio?.valore.VideoConferenza, storicoUfficio?.valorePrecedente.VideoConferenza)}

                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Altre sedi
                                </TableCell>
                                <TableCell>
                                    {storicoUfficio?.valore.AltreSedi ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Altre sedi", storicoUfficio?.valore.AltreSedi, storicoUfficio?.valorePrecedente.AltreSedi)}

                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Informazioni
                                </TableCell>
                                <TableCell>
                                    {storicoUfficio?.valore.InfoAggiuntive ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Informazioni", storicoUfficio?.valore.InfoAggiuntive, storicoUfficio?.valorePrecedente.InfoAggiuntive)}

                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Latitudine
                                </TableCell>
                                <TableCell>
                                    {storicoUfficio?.valore.Latitudine ?? '-'}
                                </TableCell>find
                            </TableRow> */}
                            {buildTableCellRowComponent("Latitudine", storicoUfficio?.valore.Latitudine, storicoUfficio?.valorePrecedente.Latitudine)}

                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Longitudine
                                </TableCell>
                                <TableCell>
                                    {storicoUfficio?.valore.Longitudine ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Longitudine", storicoUfficio?.valore.Longitudine, storicoUfficio?.valorePrecedente.Longitudine)}

                            {/* <TableRow> 
                                <TableCell style={{ width: "20%" }}>
                                    Zona
                                </TableCell>
                                <TableCell>
                                    {ZonaOptions.find(e => e.zona == storicoUfficio?.valore.zona)?.label ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Zona", ZonaOptions.find(e => e.zona == storicoUfficio?.valore.zona)?.label ?? '-', ZonaOptions.find(e => e.zona == storicoUfficio?.valorePrecedente.zona)?.label ?? '-')}

                            {/* <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                    Zona riferimento
                                </TableCell>
                                <TableCell>
                                    {storicoUfficio?.valore.ZonaRiferimento ?? '-'}
                                </TableCell>
                            </TableRow> */}
                            {buildTableCellRowComponent("Zona riferimento", storicoUfficio?.valore.ZonaRiferimento, storicoUfficio?.valorePrecedente.ZonaRiferimento)}

                        </TableBody>
                    </Table>
                </AccordionDetails>
            </Accordion>
        </>
    );
}